import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { Button, NamedLink, ExternalLink } from '../../../components';

import item1Img from "./item1.svg"
import item2Img from "./item2.svg"
import item3Img from "./item3.svg"
import classNames from "classnames";

import css from './SectionHowGetStarted.module.css';
import { getBullets } from '../../../util/contentful';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const SectionHowGetStarted = props => {
  const { handleGetStarted, currentUser, isTeacher, content } = props;

  const items = content && getBullets(content, 'howOption');
  const buttonText = content?.howButtonText ?
    content.howButtonText :
    <FormattedMessage id='SectionHowGetStarted.getStarted' />

  return (
    <div className={css.root}>
      <div className={css.rootTitleHolder}>
        <h2 className={css.rootTitle}>
          {content?.howTitle ?
            content.howTitle :
            <FormattedMessage id="SectionHowGetStarted.title" />
          }
        </h2>
      </div>

      <p className={css.rootDescription}>
        {content?.howDescription ?
          content.howDescription :
          <FormattedMessage id="SectionHowGetStarted.description" />
        }
      </p>

      <div className={css.infoList}>
        {content && items ? Array.from(Array(Object.keys(items).length / 4).keys()).map(i => (
          <ExternalLink key={`howOption${i + 1}Icon`} href={items[`howOption${i + 1}Link`]} className={css.infoItem}>
            <div className={css.infoImage}>
              <img src={`https:${items[`howOption${i + 1}Icon`].fields?.file?.url}`} className={css.image} />
            </div>
            <h3 className={css.infoTitle}>
              {items[`howOption${i + 1}Title`]}
            </h3>
            <div className={css.infoText}>
              {documentToReactComponents(items[`howOption${i + 1}Description`])}
            </div>
          </ExternalLink>
        )) : <>
          <div className={css.infoItem}>
            <div className={css.infoImage}>
              <img src={item1Img} className={css.image} />
            </div>
            <h3 className={css.infoTitle}>
              <FormattedMessage id="SectionHowGetStarted.itemTitle1" />
            </h3>
            <div className={css.infoText}>
              <FormattedMessage id="SectionHowGetStarted.itemDescription1" />
            </div>
          </div>

          <div className={classNames(css.infoItem)}>
            <div className={css.infoImage}>
              <img src={item2Img} className={css.image} />
            </div>
            <h3 className={css.infoTitle}>
              <FormattedMessage id="SectionHowGetStarted.itemTitle2" />
            </h3>
            <div className={css.infoText}>
              <FormattedMessage id="SectionHowGetStarted.itemDescription2" />
            </div>
          </div>

          <div className={css.infoItem}>
            <div className={css.infoImage}>
              <img src={item3Img} className={css.image} />
            </div>
            <h3 className={css.infoTitle}>
              <FormattedMessage id="SectionHowGetStarted.itemTitle3" />
            </h3>
            <div className={css.infoText}>
              <FormattedMessage id="SectionHowGetStarted.itemDescription3" />
            </div>
          </div>
        </>}
      </div>

      <div className={css.buttonHolder}>
        {!currentUser && (
          <Button className={css.primaryButton} onClick={handleGetStarted}>
            {buttonText}
          </Button>
        )}
        {currentUser && !isTeacher && (
          <NamedLink name="NewJobPage" className={css.primaryButton}>
            {buttonText}
          </NamedLink>
        )}
      </div>
    </div>
  );
};

export default SectionHowGetStarted;
